<template>
  <div class="rowSectionForm">
    <ul class="rowSectionForm-params">
      <li>Высота: {{ data.height }}</li>
      <li>Глубина: {{ data.depth }}</li>
    </ul>
    <div class="rowSectionForm-fieldset">
      <div class="rowSectionForm-field">
        <label>Длина</label>
        <Select
          v-model="width"
          :options="options.width"
        />
      </div>
      <div class="rowSectionForm-field">
        <label>Кол-во полок</label>
        <Select
          v-model="count"
          :options="options.count"
        />
      </div>
      <div class="rowSectionForm-field">
        <label>Вид полок</label>
        <Select
          v-model="type"
          :options="options.type"
        />
      </div>
      <div class="rowSectionForm-field">
        <Checkbox
          :value="couplerValue"
          :disabled="couplerDisabled"
          @input="coupler = $event"
        >
          Стяжки
        </Checkbox>
        <br>
        <small>
          Рекомендована установка при планируемой нагрузке на ярус свыше 250 кг
        </small>
      </div>
      <button
        class="rowSectionForm-submit"
        @click="submit"
      >
        Применить
      </button>
    </div>
  </div>
</template>

<script>
  import Select from './Select';
  import Checkbox from './Checkbox';

  export default {
    name: 'RowSectionForm',
    inject: {
      options: 'options',
    },
    components: {
      Select,
      Checkbox,
    },
    props: {
      data: Object,
    },
    data() {
      return {
        capacity: 0,
        height: 0,
        depth: 0,
        width: 0,
        count: 0,
        type: null,
        coupler: false,
        ...this.data,
      };
    },
    computed: {
      isMetal() {
        return this.type === 'metal';
      },
      couplerValue() {
        return this.isMetal || this.depth == 760 || this.depth == 910 ? true : this.coupler;
      },
      couplerDisabled() {
        return this.isMetal || this.depth == 760 || this.depth == 910;
      },
    },
    methods: {
      submit() {
        this.$emit('submit', {
          ...this.$data,
          coupler: this.couplerValue,
        });
      },
    },
  }
</script>

<style scoped>
  .rowSectionForm {
    display: flex;
    flex-direction: column;
  }
  .rowSectionForm-submit {
    padding: 16px;
    width: 146px;
    max-width: 100%;
  }
  .rowSectionForm-params {
    margin: 0;
    padding: 0;
    list-style: none;
    font-size: 14px;
    color: #A7A7A7;
  }
  .rowSectionForm-params > li {
    margin-bottom: 8px;
  }
  .rowSectionForm-fieldset {
    margin: auto 0;
  }
  .rowSectionForm-field {
    margin: 22px 0 30px;
  }
  select {
    margin-top: 10px;
    width: 100%;
  }
</style>
